export default __webpack_public_path__ + "static/media/roboto-medium-webfont.e55da4ae.woff2";